import { getBannerById } from "../services/banner.service";

const bannerList = [
  { type: "home", id: 1 },
  { type: "about", id: 2 },
  { type: "howto", id: 5 },
  { type: "services", id: 3 },
  { type: "contact", id: 4 },
];

export const findBannerElement = (bannerInfo) => {
  const banners = document.querySelectorAll("[data-banner]");
  return [...banners].find(
    (banner) => banner.getAttribute("data-banner") === bannerInfo.type
  );
};

export const getBanners = async () => {
  try {
    const bannerPromises = bannerList.map(async (bannerInfo) => {
      const bannerElement = findBannerElement(bannerInfo);
      if (bannerElement) {
        const resp = await getBannerById(bannerInfo.id);
        const imageUrl = resp.imageUrl;
        bannerElement.style.backgroundImage = `url(${imageUrl})`;
      }
    });
    await Promise.all(bannerPromises);
    console.log("All banners have been updated.");
  } catch (error) {
    console.error("Error fetching banner data:", error);
  }
};
